import RootHub from "./root-hubs";
import useSignalRClient from "./signalr-hubs";
import { useDispatch, useSelector } from "react-redux";
import {
  selectFeatures,
  selectFeaturesLoaded,
} from "@/store/slices/features/featuresSlice";
import FeatureService from "@/services/feature-service";
import { FeatureKeys } from "@/services/dropdown-enums";
import {
  setRequestToState,
  unsetRequestFromState,
} from "@/store/slices/requests";
import Convo_signalr from "@/modules/crm/leads/convo-signalr-contants";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import { useRouter } from "next/router";
import { getCookie } from "../generic.methods";
import PublicHub from "./public-hubs";
import Report_Dashboard_signalr from "@/modules/crm/analytics/report-dashboard-signalr-constants";

const {
  InvokeMethodNames: { startConvo, sendMessage },
} = Convo_signalr;

const {
  onReceiveMethodNames: { onNotificationArrived, onUpdateNotificationResponse },
} = Lead_signalr;

// list of listeners that are no needed to subscribed initially
const NotToSubscribedMethods = [
  startConvo,
  sendMessage,
  onNotificationArrived,
  onUpdateNotificationResponse,
];

const OnInitHub = (props, clientName) => {
  const { publicUrl = false } = props || {};
  const dispatch = useDispatch();
  const router = useRouter();
  let { query } = router;
  const isCrm = router.asPath.split("/")?.[1] == "crm";
  const features = useSelector(selectFeatures);
  const featuresLoaded = useSelector(selectFeaturesLoaded);
  let hubNames = [];
  let MainHub = [];
  const auth = getCookie("CRM-Auth");
  if (publicUrl) {
    hubNames = PublicHub.map((hub) => hub.hubName);
    MainHub = PublicHub;
  } else if (
    isCrm &&
    auth &&
    featuresLoaded &&
    FeatureService.hasFeature(features, FeatureKeys.CRM)
  ) {
    hubNames = RootHub.map((hub) => hub.hubName);
    MainHub = RootHub;
  } else if (
    isCrm &&
    auth &&
    FeatureService.hasFeature(features, FeatureKeys.APPOINTMENT_SCHEDULING)
  ) {
    // for appointment only user
    hubNames = [{ ...Report_Dashboard_signalr }].map((hub) => hub.hubName);
    MainHub = [{ ...Report_Dashboard_signalr }];
  }
  const { statuses, RTC } = useSignalRClient({
    hubName: hubNames,
    companyKey: query?.companykey,
    isPublic: !!publicUrl,
  });

  const initOnReceiveMethods = () => {
    console.log("onReceiveMethods", clientName, "==/=");
    getResponseMethods();
  };

  const getResponseMethods = () => {
    MainHub.map((hub) => {
      for (let key in hub.onReceiveMethodNames) {
        let methodName = hub.onReceiveMethodNames[key];
        if (methodName && !NotToSubscribedMethods.includes(methodName)) {
          // console.log("hub::", hub.hubName, "method ::", methodName);
          onReceive(hub.hubName, methodName);
        }
      }
    });
  };

  const onReceive = (hubName, methodName) => {
    let hub = RTC[hubName];
    let methodNameLower = methodName.toLowerCase();
    let activeListners = Object.keys(hub?._methods || {});
    console.log(hub, activeListners, hubName, methodName, "active listners");
    if (hub && !activeListners.includes(methodNameLower)) {
      hub.on(methodName, (response) => {
        console.log(`${methodName} response::`, response);
        // do some work here
        let payload = { key: methodName, data: response };
        dispatch(setRequestToState(payload));
      });
    }
  };

  const clearStateByMethods = (methodNames = []) => {
    dispatch(unsetRequestFromState({ keys: methodNames }));
  };

  return { initHub: initOnReceiveMethods, clearStateByMethods };
};

export default OnInitHub;
